import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, Button } from "react-bootstrap";
import "./EditAvatar.scss";


const EditAvatar = ( { onSubmit } ) => {
  const { t } = useTranslation();
  const [avatar, setAvatar] = useState(null);

  const onAvatarChange = (event) => { 
    setAvatar(event.target.files[0]);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData();  
    formData.append( 
      "avatar", 
      avatar,
    );
    onSubmit(formData);
  };

  return (
    <div className="EditAvatar">
      <h4>{t("profile:avatarheader")}</h4>
      <Form onSubmit={handleSubmit}>
        <input
          type="file"
          className="btn btn-input-avatar mr-3"
          onChange={onAvatarChange}
          accept="image/*"
        />
        <Button
          type="submit" 
          className="btn btn-submit-avatar">
          {t("profile:cta")} 
        </Button>
      </Form>
    </div>
  );
};

export default EditAvatar;